<template>
  <div class="footer-container">
    <h1>Footer</h1>
  </div>
</template>

<script>
export default {
  name: "Footer",
  components: {},
  data() {
    return {}
  },// data
  methods: {},// methods
  watch: {
    // 'searchParamVo.topPath': {handler: function (val, oldVal) {if (val) {this.searchParamVo.topPath = val;this.searchParamVo.topPath = '';}}, deep: true},
  },// watch
  mounted() {
    // this.init();
  },// mounted
}
</script>

<style scoped>
.footer-container {
  height: 40px;
  background-color: #67C23A;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
}
.footer-container h1 {
  margin: 0;
  font-size: 16px;
}
</style>